import { COLORS } from '@/styles/colors';
import styled, { keyframes } from 'styled-components';

export const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderNewWrapper = styled.div<{ size: 'small' | 'medium' }>`
  width: 40px;
  height: 40px;
  border: 5px solid ${COLORS.black};
  border-bottom-color: ${COLORS.green[400]};
  border-radius: 50%;
  animation: ${rotation} 1s linear infinite;

  ${({ size }) =>
    size === 'small' &&
    `
      width: 36px;
      height: 36px;
    `};
`;
